import { Stack } from '@mui/material';
import {
  ConfirmationModal,
  PrimaryButton,
} from '@/components';
import { useBoolean } from 'usehooks-ts';

type CreateUserActionsProps = {
  onClose: () => void;
  submit: () => void;
  loading: boolean;
  valid: boolean;
};

export const CreateUserActions = (props: CreateUserActionsProps) => {
  const { 
    value: shouldShowConfirmation, 
    toggle: toggleConfirmation, 
  } = useBoolean();

  const handlePrompt = () => {
    console.log('Valid:', props.valid);
    if (props.valid) {
      toggleConfirmation();
    } else {
      props.submit();
    }
  };

  const handleConfirmation = () => {
    props.submit();
    toggleConfirmation();
  };

  return (
    <Stack direction="row" gap={2} justifyContent="flex-end">
      <PrimaryButton
        onClick={handlePrompt}
        sx={{ padding: '10px 50px' }}
        loading={props.loading}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: 4 }}
        >
          <path
            d="M12 5V19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M5 12H19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg> 
        Create User
      </PrimaryButton>
      <ConfirmationModal
        open={shouldShowConfirmation}
        isPending={props.loading}
        onClose={toggleConfirmation}
        title="Delete user?"
        content="Do you want to proceed creating this account?"
        cancelActionTitle="Cancel"
        confirmActionTitle="Yes"
        onConfirm={handleConfirmation}
        onCancel={toggleConfirmation}
      />
    </Stack>
  );
};
